import { Component, OnInit, ViewChild, ElementRef, EventEmitter, Output, Input, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { GlobalConstants } from '../../../../app/common/constants/global.constant';
import { AssetLibraryConstants } from '../../../core/routing/services/asset-library/constants/asset-library.constant';
import { SegmentsConfiguration, CreateSegmentsResponse, SegmentViewModel, Segment} from '../segments/interfaces/segments.i';
import { SegmentsService } from '../../../core/routing/services/asset-library/segments.service';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { first } from 'rxjs/internal/operators/first';
import { Subject } from 'rxjs/internal/Subject';
import { DataService } from '../../../core/data/data-service';
import { CommonService } from '../../../common/services/common.service';
import { Router } from '@angular/router';
import { ProfileRequest, Segment as SegmentProfile } from '../../../../app/modules/create-profile/interface/profile.i';
import { CreateProfileService } from '../../../core/routing/services/profile/create-profile.service';
import moment from 'moment';
import { Utils } from '../../../common/utils/utils';
import { FormFactor } from '../form-factors/interfaces/form-factors.i';
import { AppGlobal } from '../../../core/state/app-global';
import { User } from '../../account/login/_models/user.model';

@Component({
  selector: 'iposcen-create-segments',
  templateUrl: './create-segments.component.html',
  styleUrls: ['./create-segments.component.scss']
})
export class CreateSegmentsComponent implements OnInit, OnDestroy {
  @Input() pageNumber: number;
  @Input() contentGroupType: string;
  @Input() presentPage: string;
  @Input() isNavigated: boolean;
  @Output() readonly goBacktoSegmentContent = new EventEmitter<object>();
  @ViewChild('colorpicker') colPicModal: ElementRef;
  @ViewChild('formFactorsModal') formFactorsModal: ElementRef;
  segmentThemeForm;
  brandColorThemeForm;
  isPublishedDateInCorrect: boolean;
  isExpiredDateIncorrect: boolean;
  isPublishDateCustomDatepicker: boolean;
  isExpiryDatePicker: boolean;
  isSubmitted: boolean;
  isFormValid: boolean;
  segmentsForm: FormGroup;
  isEdit = false;
  selectedSegmentId: string;
  selectedSegment: SegmentViewModel;
  selectedFormFactors: FormFactor;
  segmentCGToDeleteName: string;
  dateTimeValue: string;
  currentDetailPage: string;
  createdSegmentId: string;
  profileData: string;
  publishDateValues: string;
  customPublishDateResult: string;
  customExpiryDateResult: string;
  ispublishDateNowStatus: boolean;
  editPublishDateInfo: string;
  editexpiryDateInfo: string;
  isPublishExpiryNever: boolean;
  isCustomPublishDateCorrect: boolean;
  isCustomExpiryDateCorrect: boolean;
  updatedSelectedSegment: SegmentViewModel;
  segmentData: SegmentsConfiguration;
  deviceTypes = GlobalConstants.DEVICE_TYPES;
  manufacturers = GlobalConstants.MANUFACTURERS;
  processors = GlobalConstants.PROCESSORS;
  generation = GlobalConstants.GENERATION;
  userId: string = sessionStorage.getItem(GlobalConstants.USER_ID);
  userRole: string = sessionStorage.getItem(GlobalConstants.USER_ROLE);
  retailerId: string = sessionStorage.getItem(GlobalConstants.RETAILER_ID);
  retailHQUser: string = GlobalConstants.RETAIL_HQ_USER;
  storeUser: string = GlobalConstants.STORE_USER;
  regionalUser: string = GlobalConstants.REGIONALHQ;
  isBrandColorEnabled = false;
  iposBrandColor: string;
  isBrandColorChecked: boolean = true;
  isSegmentColorChecked: boolean = false;
  isNoColorChecked: boolean = false;
  iposBackgroundType: string;
  enterHeadlinePlaceholder = AssetLibraryConstants.ENTER_HEADLINE_PLACEHOLDER;
  enterSubHeadlinePlaceholder = AssetLibraryConstants.ENTER_SUB_HEADLINE_PLACEHOLDER;
  enterRetailerNamePlaceholder = AssetLibraryConstants.ENTER_RETAILER_NAME_PLACEHOLDER;
  colorInfoTooltip = AssetLibraryConstants.COLOR_INFO_TOOLTIP;
  brandColor = GlobalConstants.BRAND;
  segmentColor = GlobalConstants.SEGMENT;
  noneColor = GlobalConstants.NONE;
  retailerConfig: any;
  isArabic = localStorage.getItem('preferredLanguage') === 'ar-sa';
  isHebrew = localStorage.getItem('preferredLanguage') === 'he';
  changePlacement: boolean;
  isCustomPublishTimeZoneSelected = false;
  isCustomExpiryTimeZoneSelected = false;  
  private modalRef: NgbModalRef;
  private ngUnsubscribe = new Subject<boolean>();
  constructor(
    private modalService: NgbModal,
    private formBuilder: FormBuilder,
    private segmentsService: SegmentsService,
    private dataService: DataService,
    private commonService: CommonService,
    private router: Router,
    private createProfileService: CreateProfileService,
    private appGlobal: AppGlobal
  ) { }

  ngOnInit(): void {
    if (this.isArabic || this.isHebrew) {
      this.changePlacement = true;
    }
    this.dateTimeValue = '';
    this.isExpiryDatePicker = false;
    this.isExpiredDateIncorrect = false;
    this.isCustomPublishDateCorrect = false;
    this.isCustomExpiryDateCorrect = false;
    this.customPublishDateResult = GlobalConstants.NOW;
    this.customExpiryDateResult = GlobalConstants.NEVER;
    this.dataService.getSegment()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((segmentToEdit: any) => {
        if (segmentToEdit) {
          this.updatedSelectedSegment = segmentToEdit as unknown as SegmentViewModel;
          this.segmentsService.buttonName = GlobalConstants.SAVE_CHANGES;
          this.isEdit = true;
          this.selectedSegment = segmentToEdit;
          this.selectedSegmentId = segmentToEdit.id;
          this.selectedFormFactors = this.selectedSegment.configurations.formFactor;
          this.iposBackgroundType = this.selectedSegment.configurations.iposBackgroundType !== '' ? this.selectedSegment.configurations.iposBackgroundType : '';  
          if (segmentToEdit.configurations.isPublishDateNow) {
            this.isPublishDateCustomDatepicker = false;
            this.editPublishDateInfo = GlobalConstants.NOW;
          } else {
            this.isPublishDateCustomDatepicker = true;
            this.customPublishDateResult = segmentToEdit.configurations.publishTime;
            this.editPublishDateInfo = segmentToEdit.configurations.publishTime;
          }
          if (segmentToEdit.configurations.isPublishExpiryNever) {
            this.isExpiryDatePicker = false;
            this.editexpiryDateInfo = GlobalConstants.NEVER;
          } else {
            this.isExpiryDatePicker = true;
            this.customExpiryDateResult = segmentToEdit.configurations.expireTime;
            this.editexpiryDateInfo = segmentToEdit.configurations.expireTime;
          }
        } else {
          this.segmentsService.buttonName = GlobalConstants.SAVE_AND_PROCEED;
          this.iposBackgroundType = GlobalConstants.BRAND;
          this.selectedFormFactors = {
            allDevices: true,
            devices: GlobalConstants.ALL,
            manufacturer: GlobalConstants.ALL,
            processors: GlobalConstants.ALL,
            generations: GlobalConstants.ALL
          };
        }
      });
    this.appGlobal.$userAccount
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((userAccount: User) => {
        this.userRole = userAccount.role;
      });
    this.getRetailerInfo();
    this.prepareSegmentThemeForm();
    this.isSubmitted = false;
    this.createSegmentGroupForm();
    //To get original contengrouppages for normal edit flow
    if (this.selectedSegmentId) {
      this.segmentsService.getSegmentById(this.selectedSegmentId)
        .pipe(takeUntil(this.ngUnsubscribe))
        .pipe(first())
        .subscribe(getSegmentById => {
          this.segmentData = JSON.parse(getSegmentById.segment.configurations) as SegmentsConfiguration;
        },
          error => {
            // do something
          });
      this.applyChangesToLivePreview(this.segmentThemeForm);
    }
    this.commonService.getRetailGifValue
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(data => {
        if (data === true) {
          this.commonService.setSwitchstatus(true);
        }
      });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  createSegmentGroupForm() {
    // TODO -- need to add validations for form fields
    this.segmentsForm = this.formBuilder.group({
      headline: new FormControl((this.selectedSegment) ? this.selectedSegment?.configurations?.publishedName : '',
        [Validators.required, Validators.maxLength(50)]),
      subHeadline: new FormControl((this.selectedSegment) ? this.selectedSegment?.configurations?.internalName : '',
        [Validators.maxLength(50)]),
      retailerName: new FormControl((this.selectedSegment) ? this.selectedSegment?.configurations?.retailerName : '',
        [Validators.maxLength(50)]),
      publishedTimeStamp: new FormControl((this.selectedSegment) ? this.selectedSegment?.configurations?.publishTime : ''),
      expiryTimeStamp: new FormControl((this.selectedSegment) ? this.selectedSegment?.configurations?.expireTime : ''),
      isApplyToIpos: new FormControl((this.selectedSegment) ? this.selectedSegment?.configurations?.isApplyToIpos : false)
    });
  }

  prepareSegmentThemeForm() {
    this.segmentThemeForm = {
      bgcolor: this.selectedSegment ? this.selectedSegment?.configurations?.segmentBgColor : '#0068B5',
      hcolor: this.selectedSegment ? this.selectedSegment?.configurations?.segmentFontColor : '#ffffff',
      isApplyToIpos: this.selectedSegment ? this.selectedSegment?.configurations?.isApplyToIpos : false
    };
    this.brandColorThemeForm = {
      bgcolor: this.selectedSegment ? this.selectedSegment?.configurations?.segmentBgColor : '#0068B5',
      hcolor: this.selectedSegment ? this.selectedSegment?.configurations?.segmentFontColor : '#ffffff',
      iposBrandColor: '#0068B5',
      isIposBrandColor: false
    }
  }

  getRetailerInfo() {
    if (this.userRole === this.retailHQUser || this.userRole === this.storeUser || this.userRole === this.regionalUser) {
      this.createProfileService.getUserRoleData(this.userId, this.retailerId)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(data => {
          const retailerConfig = JSON.parse(data.retailer.configurations);
          if (retailerConfig.bandColor === undefined) {
            this.isBrandColorEnabled = false;
          } else {
            this.isBrandColorEnabled = retailerConfig.bandColor;
            this.iposBrandColor = retailerConfig.bgcolor;
          }
          //Fix for IIT2-6952 starts
          if (this.isBrandColorEnabled && this.iposBackgroundType === '') this.iposBackgroundType = GlobalConstants.BRAND;
          //Fix for IIT2-6952 ends
          if (this.isBrandColorEnabled) {
            if (this.iposBackgroundType === GlobalConstants.BRAND_COLOR || this.iposBackgroundType === this.brandColor) {
              this.brandColorThemeForm.iposBrandColor = this.iposBrandColor;
              this.brandColorThemeForm.isIposBrandColor = this.isBrandColorEnabled;
              this.applyChangesToLivePreview(this.brandColorThemeForm);
            } else {
              this.isBrandColorChecked = false;
              this.isSegmentColorChecked = (
                this.iposBackgroundType === GlobalConstants.SEGMENT_COLOR || this.iposBackgroundType === this.segmentColor
              ) ? true : false;
              this.isNoColorChecked = (
                this.iposBackgroundType === GlobalConstants.NONE_COLOR || this.iposBackgroundType === this.noneColor
              ) ? true : false;
              this.segmentThemeForm.isApplyToIpos = (
                this.iposBackgroundType === GlobalConstants.SEGMENT_COLOR || this.iposBackgroundType === this.segmentColor
              ) ? true : false;
              this.applyChangesToLivePreview(this.segmentThemeForm);
            }
          }
        });
    }
  }

  chooseTheme(fontColor: string, bgColor: string) {
    [
      this.segmentThemeForm.bgcolor,
      this.segmentThemeForm.hcolor
    ] =
      [
        bgColor,
        fontColor
      ];
    if (this.iposBackgroundType === GlobalConstants.BRAND_COLOR || this.iposBackgroundType === this.brandColor) {
      [
        this.brandColorThemeForm.bgcolor,
        this.brandColorThemeForm.hcolor
      ] =
        [
          bgColor,
          fontColor
        ];
      this.applyChangesToLivePreview(this.brandColorThemeForm);
    } else {
      this.applyChangesToLivePreview(this.segmentThemeForm);
    }
    this.dismiss();
  }

  fontSize(size) {
    if (size === GlobalConstants.SMALL) { return GlobalConstants.FONTSIZE_12PX; }
    if (size === GlobalConstants.MEDIUM) { return GlobalConstants.FONTSIZE_14PX; }
    if (size === GlobalConstants.LARGE) { return GlobalConstants.FONTSIZE_16PX; }
  }

  isSelected(hcolor, bgcolor) {
    if (this.segmentThemeForm.hcolor === hcolor && this.segmentThemeForm.bgcolor === bgcolor) {
      return true;
    }

    return false;
  }

  openColPicModal() {
    this.modalRef = this.modalService.open(this.colPicModal);
    this.modalRef.result.then();
  }

  dismiss() {
    this.modalRef.close();
  }

  checkPublishedDateTime() {
    this.isSubmitted = false;
    const today = new Date();
    let isPublishedDateSmaller;
    if (this.segmentsForm.controls.publishedTimeStamp.toString() !== '') {
      isPublishedDateSmaller = new Date(this.segmentsForm.controls.publishedTimeStamp.value).getTime() < new Date().getTime();
    }

    this.isPublishedDateInCorrect = isPublishedDateSmaller;
  }

  // check if expiry date is smaller than published date
  checkExpiryDateTime() {
    if (this.customExpiryDateResult !== GlobalConstants.NEVER) {
      this.isExpiredDateIncorrect = Utils.customDateCheck(this.customPublishDateResult, this.customExpiryDateResult);
    }
  }

  customValidation() {
    if (this.isPublishDateCustomDatepicker) {
      this.isCustomPublishDateCorrect = (this.customPublishDateResult === GlobalConstants.NOW);
    }
    if (this.isExpiryDatePicker) {
      this.isCustomExpiryDateCorrect = (this.customExpiryDateResult === GlobalConstants.NEVER);
    }
  }

  onAdd() {
    this.isSubmitted = true;
    this.checkExpiryDateTime();
    this.customValidation();
    this.isFormValid = !this.isPublishedDateInCorrect &&
      !this.isExpiredDateIncorrect &&
      !this.isCustomExpiryDateCorrect &&
      !this.isCustomPublishDateCorrect &&
      this.segmentsForm?.controls?.headline?.value.trim() !== ''
      && !this.segmentsForm?.controls?.headline?.errors?.maxlength &&
      !this.isCustomPublishTimeZoneSelected && !this.isCustomExpiryTimeZoneSelected;
    if (this.isFormValid) {
      this.iposBackgroundType = this.checkIfBGTypeHasOldValues();
      if (this.selectedSegmentId) {
        this.updateSegment();
      } else {
        this.createSegment();
      }
    }
  }
  openModal(modal: any) { modal.open(); }
  closeModal(modal: any) { modal.close(); }

  // Function to convert if iposBackgroundType has old values
  checkIfBGTypeHasOldValues() {
    if (this.iposBackgroundType === GlobalConstants.BRAND_COLOR) {
      return this.brandColor;
    } else if (this.iposBackgroundType === GlobalConstants.SEGMENT_COLOR) {
      return this.segmentColor;
    } else if (this.iposBackgroundType === GlobalConstants.NONE_COLOR) {
      return this.noneColor;
    } else {
      return this.iposBackgroundType;
    }
  }

  openFormFactorsModal() {
    this.openModal(this.formFactorsModal);
  }

  applyFormFactor(updatedFormFactors) {
    this.selectedFormFactors = updatedFormFactors;
    this.closeModal(this.formFactorsModal);
  }

  createSegment() {
    const segmentFactor: FormFactor = Utils.getFormFactorValues(this.selectedFormFactors);
    const segment: SegmentsConfiguration = {
      publishedName: this.segmentsForm.controls.headline.value.trim(),
      internalName: this.segmentsForm.controls.subHeadline.value,
      retailerName: this.segmentsForm.controls.retailerName.value,
      segmentBgColor: this.segmentThemeForm.bgcolor,
      segmentFontColor: this.segmentThemeForm.hcolor,
      publishTime: (this.customPublishDateResult.toString() !== GlobalConstants.NOW) ?
        this.customPublishDateResult.toString() : Utils.getCurrentDate(),
      expireTime: (this.customExpiryDateResult.toString() !== GlobalConstants.NEVER) ?
        this.customExpiryDateResult.toString() : GlobalConstants.NEVER,
      contentScheduleTimezoneCode: 'CST',
      type: GlobalConstants.SEGMENTS,
      contentGroupPages: [],
      formFactor: segmentFactor,
      isApplyToIpos: this.segmentsForm.controls.isApplyToIpos.value,
      isPublishDateNow: !this.isPublishDateCustomDatepicker,
      isPublishExpiryNever: !this.isExpiryDatePicker,
      iposBackgroundType: (this.isBrandColorEnabled) ?
        this.iposBackgroundType : "" // Pass "" if loggedin User is not RETAIL HQ User
    };
    if (segment.expireTime !== GlobalConstants.NEVER) {
      segment.expireTime = Utils.changeSaveDateFormat(segment.expireTime);
    }
    if (!segment.isPublishDateNow) {
      segment.publishTime = Utils.changeSaveDateFormat(segment.publishTime);
    }
    this.segmentsService.createSegment(JSON.stringify(segment))
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(createSegmentsResponse => {
        const createSegmentsResponseObj: CreateSegmentsResponse = createSegmentsResponse as CreateSegmentsResponse;
        this.createdSegmentId = createSegmentsResponseObj.segment.id;
        this.currentDetailPage = this.router.url;
        const pageName = this.currentDetailPage.lastIndexOf('/');
        if (this.currentDetailPage.substring(pageName + 1) === GlobalConstants.CREATE_PROFILE) {
          this.profileData = this.createProfileService.getProfileId();
          const segmentInfo: SegmentProfile = {
            segmentId: this.createdSegmentId,
            showOnDevice: true
          };
          const profileRequest: ProfileRequest = {
            segments: [segmentInfo]
          };
          this.createProfileService.updateProfile(this.profileData, profileRequest)
            .pipe(takeUntil(this.ngUnsubscribe))
            .pipe(first())
            .subscribe(response => {
              this.goBacktoSegmentContent.emit(createSegmentsResponseObj);
            },
              error => {
              });
        } else {
          this.goBacktoSegmentContent.emit(createSegmentsResponseObj);
        }
      },
        error => {
        }
      );
  }

  cancel() {
    this.isSubmitted = false;
    this.goBacktoSegmentContent.emit({ cancel: true });
    this.dataService.setSegment(undefined);
    //***Fix for IIT2-6952 starts***
    if (this.presentPage === GlobalConstants.PROFILE) {
      this.brandColorThemeForm.bgcolor = GlobalConstants.STORELOGO_BGCOLOR;
      this.brandColorThemeForm.iposBrandColor = '';
      this.brandColorThemeForm.isIposBrandColor = false;
      this.applyChangesToLivePreview(this.brandColorThemeForm);
    }
    //***Fix for IIT2-6952 ends***
  }

  updateSegment() {
    const segmentFactor: FormFactor = Utils.getFormFactorValues(this.selectedFormFactors);
    const segment = this.selectedSegment as unknown as Segment;
    if(segment.configurations['previewType'] == undefined || segment.configurations['idleExpFullscreenEnabled'] == undefined) {
      segment.configurations['previewType'] = GlobalConstants.LIVE_PREVIEW_PREVIEW_TAB_IPOS;
      segment.configurations['idleExpFullscreenEnabled'] = false;
    }
    const segmentConfig: SegmentsConfiguration = {
      publishedName: this.segmentsForm.controls.headline.value.trim(),
      internalName: this.segmentsForm.controls.subHeadline.value,
      retailerName: this.segmentsForm.controls.retailerName.value,
      segmentBgColor: this.segmentThemeForm.bgcolor,
      segmentFontColor: this.segmentThemeForm.hcolor,
      publishTime: (this.customPublishDateResult.toString() !== GlobalConstants.NOW) ?
        this.customPublishDateResult.toString() : Utils.getCurrentDate(),
      expireTime: (this.customExpiryDateResult.toString() !== GlobalConstants.NEVER) ?
        this.customExpiryDateResult.toString() : GlobalConstants.NEVER,
      contentScheduleTimezoneCode: 'CST',
      formFactor: segmentFactor,
      type: GlobalConstants.SEGMENTS,
      contentGroupPages: this.segmentData.contentGroupPages,
      isApplyToIpos: this.segmentsForm.controls.isApplyToIpos.value,
      isPublishDateNow: !this.isPublishDateCustomDatepicker,
      isPublishExpiryNever: !this.isExpiryDatePicker,
      iposBackgroundType: (this.isBrandColorEnabled) ?
        this.iposBackgroundType : "" // Pass "" if loggedin User is not RETAIL HQ User
    };
    if (segmentConfig.expireTime !== GlobalConstants.NEVER) {
      segmentConfig.expireTime = Utils.changeSaveDateFormat(segmentConfig.expireTime);
    }
    if (!segmentConfig.isPublishDateNow) {
      segmentConfig.publishTime = Utils.changeSaveDateFormat(segmentConfig.publishTime);
    }
    const segmentConfigObj: SegmentsConfiguration = this.updatedSelectedSegment.configurations as SegmentsConfiguration;
    segment.configurations = JSON.stringify(segmentConfig);
    this.segmentsService.editSegmentById(JSON.stringify(segment), this.selectedSegmentId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(putSegmentResponse => {
        if (this.isNavigated) {
          const segmentResponseObj = { segment: putSegmentResponse.segment };
          segmentResponseObj.segment.configurations =
            JSON.parse(segmentResponseObj.segment.configurations) as SegmentsConfiguration;
          segmentResponseObj.segment.configurations.contentGroupPages = segmentConfigObj.contentGroupPages;
          this.goBacktoSegmentContent.emit(segmentResponseObj);
        } else {
          const putSegmentResponseObj: CreateSegmentsResponse = putSegmentResponse as CreateSegmentsResponse;
          this.goBacktoSegmentContent.emit(putSegmentResponseObj);
        }
        const putSegmentResponseObj: CreateSegmentsResponse = putSegmentResponse as CreateSegmentsResponse;
        this.goBacktoSegmentContent.emit(putSegmentResponseObj);
      },
        error => {
        });
  }

  updateBgColor(value: string) {
    if (this.iposBackgroundType === GlobalConstants.BRAND_COLOR || this.iposBackgroundType === this.brandColor) {
      this.brandColorThemeForm.bgcolor = value;
      this.applyChangesToLivePreview(this.brandColorThemeForm);
    } else {
      this.segmentThemeForm.bgcolor = value;
      this.applyChangesToLivePreview(this.segmentThemeForm);
    }
  }

  updateFontColor(value: string) {
    if (this.iposBackgroundType === GlobalConstants.BRAND_COLOR || this.iposBackgroundType === this.brandColor) {
      this.brandColorThemeForm.hcolor = value;
      this.applyChangesToLivePreview(this.brandColorThemeForm);
    } else {
      this.segmentThemeForm.hcolor = value;
      this.applyChangesToLivePreview(this.segmentThemeForm);
    }
  }

  selectCustomPublishDate(datetimeOption) {
    this.isPublishDateCustomDatepicker = this.checkStatus(datetimeOption);
    if (!this.isPublishDateCustomDatepicker && this.customPublishDateResult !== GlobalConstants.NOW) {
      this.customPublishDateResult = Utils.getCurrentDate();
    }
    if (datetimeOption === GlobalConstants.NOW) {
      this.isCustomPublishDateCorrect = false;
      this.isCustomPublishTimeZoneSelected = false;
    }
  }

  selectExpiryDateTimeZone(datetimeOption) {
    this.isExpiryDatePicker = this.checkStatus(datetimeOption);
    if(this.isExpiryDatePicker && this.editexpiryDateInfo) {
      this.customExpiryDateResult = this.editexpiryDateInfo;
    }
    if (!this.isExpiryDatePicker && this.customExpiryDateResult !== GlobalConstants.NEVER) {
      this.customExpiryDateResult = GlobalConstants.NEVER;
    }
    if (datetimeOption === GlobalConstants.NEVER) {
      this.isExpiredDateIncorrect = false;
      this.isCustomExpiryDateCorrect = false;
      this.isCustomExpiryTimeZoneSelected = false;
    }
  }

  checkStatus(status) {
    return (status === GlobalConstants.CUSTOM);
  }

  getLogoContentPublishDate(data) {
    this.customPublishDateResult = this.generateDateTimeZone(data);
  }

  getLogoContentExpiryDate(data) {
    this.customExpiryDateResult = this.generateDateTimeZone(data);
  }

  generateDateTimeZone(data) {
    return `${moment(data.dateVal).format(GlobalConstants.DATE_FORMAT)} ${data.hour}:${data.min} ${data.timeZone}`;
  }
  applySegmentColorToIpos(eventObj: any) {
    this.segmentThemeForm.isApplyToIpos = eventObj.target.checked;
    this.applyChangesToLivePreview(this.segmentThemeForm);
  }
  applyBackgroundColorToIpos(data) {
    if (data === GlobalConstants.BRAND_COLOR || data === this.brandColor) {
      this.iposBackgroundType = this.brandColor;
      this.brandColorThemeForm.bgcolor = this.segmentThemeForm.bgcolor;
      this.brandColorThemeForm.hcolor = this.segmentThemeForm.hcolor;
      this.brandColorThemeForm.iposBrandColor = this.iposBrandColor;
      this.brandColorThemeForm.isIposBrandColor = this.isBrandColorEnabled;
      this.applyChangesToLivePreview(this.brandColorThemeForm);
    } else {
      this.iposBackgroundType = (data === GlobalConstants.SEGMENT_COLOR || data === this.segmentColor) ? this.segmentColor : this.noneColor;
      this.segmentThemeForm.isApplyToIpos = (data === GlobalConstants.SEGMENT_COLOR || data === this.segmentColor) ? true : false;
      this.applyChangesToLivePreview(this.segmentThemeForm);
    }
  }
  applyChangesToLivePreview(theme) {
    this.commonService.emitDataToLivePreview({ page: GlobalConstants.SEGMENTS, dataSet: theme });
  }
  checkIfTimeset(data, check) {
    if (check === 'publish') {
      if (data[0] && data[1]) {
        this.isCustomPublishDateCorrect = false;
      }
    } else {
      if (data[0] && data[1]) {
        this.isCustomExpiryDateCorrect = false;
      }
    }
  }

  checkTimeZone(data, check) {
    (check === GlobalConstants.PUBLISH) ? (this.isCustomPublishTimeZoneSelected = !data) : (this.isCustomExpiryTimeZoneSelected = !data);
  }
}
